<template>
  <footer role="footer" class="Footer">
    <div class="Footer_wrapper">
      <div class="Footer_infos">
        <div class="Footer_container">
          <div class="Footer_infos_discover">
            <a href="https://www.qualitel.org/" target="_blank"><img src="../../../public/static/images/qualitel-logo-white.svg" alt="Qualitel - Pour la qualité du logement" /></a>
            <p>QUALITEL est la seule association indépendante et à but non lucratif, engagée pour la qualité de l’habitat des Français depuis 1974. Retrouvez ici tous nos outils et conseils conçus avec nos experts pour accompagner tous vos projets.</p>
            <a href="https://www.qualitel.org/presentation/" target="_blank" @click="$gtm.trackEvent({ category: 'button_footer_cta', action: 'click', label: 'footer_apropos_qualitel' })"><button class="Cta Cta_line">À propos de QUALITEL <i class="far fa-chevron-right"></i></button></a>
          </div>
          <div class="Footer_infos_share">
            <h4>Invitez vos amis à calculer leur score et découvrir l’enquête !</h4>
            <social-sharing
              url="https://www.qualitel.org/"
                title="Engagés pour un habitat meilleur"
                type="direct"
                hashtags=""
                description="Depuis 1974, nous agissons pour la qualité de l’habitat pour tous. Nos missions : informer le grand public, certifier et évaluer les logements, former les professionnels, faire des études et de la recherche."
              inline-template>

              <div class="Footer_infos_share_cta">
                <network network="facebook">
                  <button class="Cta Cta_line" @click="$gtm.trackEvent({ category: 'button_footer_share', action: 'click', label: 'footer_partage_fb' })"><i class="fab fa-facebook-square"></i> Partager sur Facebook</button>
                </network>

                <network network="twitter">
                  <button class="Cta Cta_line" @click="$gtm.trackEvent({ category: 'button_footer_share', action: 'click', label: 'footer_partage_tw' })"><i class="fab fa-twitter"></i> Partager sur Twitter</button>
                </network>
              </div>
            </social-sharing>
          </div>
        </div>
      </div>

      <div class="Footer_logos">
        <div class="Footer_container">
          <h4>Une collaboration</h4>
          <a href="https://www.qualitel.org/" target="_blank" @click="$gtm.trackEvent({ category: 'button_footer_logo', action: 'click', label: 'footer_logo_asso' })"><img src="../../../public/static/images/qualitel-logo-white.svg" alt="Qualitel - Pour la qualité du logement" /></a>
          <a href="https://www.ipsos.com/fr-fr" target="_blank" @click="$gtm.trackEvent({ category: 'button_footer_logo', action: 'click', label: 'footer_logo_ipsos' })"><img src="../../../public/static/images/ipsos-logo.svg" alt="Ipsos" /></a>
        </div>
      </div>
    </div>

    <nav class="Footer_nav">
      <div class="Footer_container">
        <div class="Footer_nav_pages">
          <a href="https://www.qualitel.org/barometre-qualitel/" target="_blank" @click="$gtm.trackEvent({ category: 'button_footer_link', action: 'click', label: 'footer_anciennes_editions' })">Anciennes éditions du Baromètre</a>
          <a href="https://www.qualitel.org/mentions-legales/" target="_blank" @click="$gtm.trackEvent({ category: 'button_footer_link', action: 'click', label: 'footer_mentions_legales' })">Conditions générales d’utilisation</a>
          <a href="https://www.qualitel.org/credits/" target="_blank" @click="$gtm.trackEvent({ category: 'button_footer_link', action: 'click', label: 'footer_credits' })">Crédits</a>
        </div>

        <div class="Footer_nav_social">
          Suivez-nous sur :
          <a href="https://www.facebook.com/groupequalitel/" target="_blank" @click="$gtm.trackEvent({ category: 'button_footer_share', action: 'click', label: 'footer_abo_fb' })"><i class="fab fa-facebook-square"></i></a>
          <a href="https://twitter.com/groupeQUALITEL" target="_blank" @click="$gtm.trackEvent({ category: 'button_footer_share', action: 'click', label: 'footer_abo_tw' })"><i class="fab fa-twitter"></i></a>
          <a href="https://www.instagram.com/associationqualitel/" target="_blank" @click="$gtm.trackEvent({ category: 'button_footer_share', action: 'click', label: 'footer_abo_insta' })"><i class="fab fa-instagram"></i></a>
          <a href="https://www.youtube.com/user/associationqualitel" target="_blank" @click="$gtm.trackEvent({ category: 'button_footer_share', action: 'click', label: 'footer_abo_yb' })"><i class="fab fa-youtube"></i></a>
        </div>
      </div>
    </nav>
  </footer>
</template>

<script>
  export default {
    name: "Footer"
  }
</script>

<style lang="stylus">
.Footer

  position relative
  background-color $blue
  color white
  width 100%

  &_container

    width 100%
    padding 0px 80px
    max-width 1366px
    margin auto
    box-sizing border-box
    display flex
    flex-direction row

    @media $medium

      padding 0px 25px

  &_wrapper

    width 100%

  h4

    font-size: 20px;
    letter-spacing: -0.22px;
    line-height: 24px;
    margin-bottom 15px

  p

    color white

  .Cta_line

    color white
    border-color white

    &:hover

      color $blue
      background-color white!important

  &_nav

    width 100%
    min-height 65px
    background-color #0A1259
    box-sizing border-box
    color white
    font-size: 14px;
    line-height: 25px;

    .Footer_container

      display flex
      flex-direction row
      align-items center
      justify-content space-between
      flex-wrap wrap
      max-width 1366px
      margin 0px auto

      @media $medium

        padding 40px 25px 30px 25px
        flex-direction column
        align-items flex-start

    &_pages

      a

        margin-right 45px

        @media $medium

          margin-right 0px
          display block

    &_social

      @media $medium

        padding 30px 0px
        margin-top 40px
        width 100%
        border-top 1px solid rgba(255,255,255,0.2)

      a

        margin-left 20px

    a

      color white
      text-decoration none
      transition opacity 0.3s $ease

      &:hover

        opacity 0.4

  &_logos

    padding 60px 0px
    text-align center
    width 100%
    background-color #0A1259

    .Footer_container

      max-width 590px
      margin auto
      display flex
      flex-wrap wrap
      justify-content space-between
      align-items center

    h4

      margin-bottom 35px
      width 100%

      @media $small

        margin-bottom 25px

    img

      height 80px

      @media $small

        height 60px

      @media $xxsmall

        height 50px

  &_infos

    padding-bottom 60px

    .Footer_container

      display flex
      flex-direction row
      align-items flex-start
      justify-content space-between

      @media $medium

        flex-direction column
        justify-content center
        align-items center

    @media $medium

      padding-bottom 40px

    &_discover

      padding-top 70px
      text-align left
      max-width 360px
      box-sizing border-box
      padding-right 30px
      width 100%

      @media $medium

        max-width unset

      img

        display block
        width 100%
        max-width 180px
        margin-bottom 20px

      .Cta

        margin-top 15px

      @media $medium

        padding-top 45px
        padding-right 0px

    &_share

      padding 70px 30px
      background-color #0A1259

      @media $medium

        padding 30px 30px
        margin-top 40px
        width calc(100% - 25px - 25px)

      h4

        max-width 360px
        display block
        text-align center
        margin auto
        margin-bottom 30px

      &_cta

        display flex
        flex-direction row
        align-items center
        justify-content center
        flex-wrap wrap

        @media $small

          flex-direction column

        span

          display flex

        .Cta

          margin 5px
          text-transform none
          padding 0px 20px

          @media $small

            margin 5px auto

          i

            margin-left 0px
            margin-right 5px

          &:hover

            i

              transform translateX(0px) scale(1.3)


.ie

  .Footer

    &_nav

      height 65px
</style>
